import PropTypes from 'prop-types'
import React from 'react'
import Input from './Input'
import { Text } from 'components/base'

const InputWithLabel = ({
  id,
  label,
  help,
  className = 'margin-top-small padding-bottom-large',
  ...inputProps
}) => {
  return (
    <div className={className}>
      <Text.Section className="margin-bottom-normal" id={id}>
        {label}
      </Text.Section>
      <Input id={id} type="text" className="block width-full" {...inputProps} />
      {help && (
        <div className="shade-20 font-size-small padding-top-normal">
          {help}
        </div>
      )}
    </div>
  )
}

InputWithLabel.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
}

export default InputWithLabel
